import { Children, ReactNode } from "react";
import { Box, SxProps, Tooltip, Typography } from "@mui/material";
import { handleIfLimitCharacter } from "src/shared/Utils/LimitText";

import { CardCore } from "../CardCore";

interface IHeaderCardCore {
  icon?: React.ReactNode;
  title?: string;
  subTitle?: string;
  limitCharacter?: number;
  buttonAdd?: ReactNode[];
  sxStyle?: SxProps;
}
export const CardHeaderCore = ({
  icon,
  title,
  subTitle,
  limitCharacter,
  buttonAdd,
  sxStyle,
}: IHeaderCardCore) => {
  return (
    <CardCore
      sxStyle={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        ...sxStyle,
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", }}
      >
        {icon && (
          <Box sx={{ display: "flex", marginRight: "10px" }}>{icon}</Box>
        )}

        <Box>
          {title && (
            <Tooltip
              title={
                limitCharacter && title.trim().length > limitCharacter && title
              }
            >
              <Typography
                sx={{
                  fontSize: { xs: ".7rem", sm: ".85rem", lg: "1rem" },
                  fontWeight: "500",
                  letterSpacing: ".5px",
                }}
              >
                {limitCharacter
                  ? handleIfLimitCharacter({
                    value: title,
                    LIMIT: limitCharacter,
                  })
                  : title}
              </Typography>
            </Tooltip>
          )}

          {subTitle && (
            <Typography sx={{ fontSize: { xs: ".7rem", sm: ".8rem" } }}>
              {subTitle}
            </Typography>
          )}
        </Box>
      </Box>

      <Box sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 2,
      }}>
        {Children.toArray(buttonAdd?.map((item) => <Box>{item}</Box>))}
      </Box>
    </CardCore>
  );
};
